var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import styles from '../ImageInput/ImageInput.module.css';
import Button from '../Button';
import { useMediaQuery } from 'react-responsive';
import classNames from 'classnames';
import Label from '../Label';
import baseStyles from '../Base.module.css';
import inputStyles from './ImageSelection.module.css';
var formatter = new Intl.NumberFormat('ru', { maximumFractionDigits: 2 });
function formatPercent(value) {
    return formatter.format(value);
}
function Modal(_a) {
    var file = _a.file, initialSelection = _a.initialSelection, updateSelection = _a.updateSelection, visible = _a.visible, close = _a.close;
    var _b = __read(useState(initialSelection), 2), crop = _b[0], setCrop = _b[1];
    var src = useMemo(function () { return (file ? URL.createObjectURL(file) : ''); }, [file]);
    var acceptCrop = function () {
        var _a, _b, _c, _d;
        updateSelection({
            x: (_a = crop === null || crop === void 0 ? void 0 : crop.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = crop === null || crop === void 0 ? void 0 : crop.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = crop === null || crop === void 0 ? void 0 : crop.width) !== null && _c !== void 0 ? _c : 0,
            height: (_d = crop === null || crop === void 0 ? void 0 : crop.height) !== null && _d !== void 0 ? _d : 0
        });
        close();
    };
    var rejectCrop = function () {
        close();
        setCrop(initialSelection);
    };
    useEffect(function () {
        if (visible) {
            document.getElementById('root').style.paddingRight = '15px';
            document.body.style.width = '100%';
            document.body.style.overflow = 'hidden';
        }
        else {
            document.getElementById('root').style.paddingRight = 'initial';
            document.body.style.width = 'initial';
            document.body.style.overflow = 'initial';
        }
    }, [visible]);
    useEffect(function () {
        if (!visible) {
            setCrop(undefined);
        }
        else {
            setCrop(initialSelection);
        }
    }, [visible]);
    var buttonStyle = { minWidth: 186 };
    var isDesktop = useMediaQuery({ query: '(min-width: 601px)' });
    var imageStyle = __assign({ objectFit: 'contain' }, (isDesktop && { maxHeight: '50vh', maxWidth: '50vw' }));
    var element = visible ? (React.createElement("div", { className: styles.backdrop, onClick: function (event) { return event.stopPropagation(); } },
        React.createElement("div", { className: styles.cropContainer },
            React.createElement("div", { className: styles.closeButtonContainer },
                React.createElement("div", null),
                React.createElement("button", { className: styles.closeButton, onClick: rejectCrop })),
            React.createElement(ReactCrop, { src: src, crop: __assign(__assign({}, crop), { unit: '%' }), onChange: function (_, newCrop) { return setCrop(newCrop); }, className: styles.imageContainer, imageStyle: imageStyle }),
            React.createElement("div", { className: styles.buttonContainer },
                React.createElement(Button, { title: '\u041E\u0442\u043C\u0435\u043D\u0430', onClick: rejectCrop, style: buttonStyle }),
                React.createElement(Button, { title: '\u041F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C', onClick: acceptCrop, style: buttonStyle }))))) : null;
    return createPortal(element, document.getElementById('root'));
}
export default function ImageSelection(props) {
    var _a, _b, _c;
    var _d = __read(useState(false), 2), modalVisible = _d[0], setModalVisible = _d[1];
    return (React.createElement("div", { className: classNames(baseStyles.control, (_a = {},
            _a[baseStyles.controlTop] = props.labelType === 'top',
            _a)) },
        props.label && (React.createElement(Label, { label: props.label, labelType: props.labelType, required: props.required })),
        React.createElement("div", { className: classNames(baseStyles.inputContainer, (_b = {},
                _b[baseStyles.inputContainerTop] = props.labelType === 'top',
                _b)), style: { display: 'flex', flexWrap: 'wrap' } },
            React.createElement("section", { className: classNames(baseStyles.controlInput, inputStyles.input, (_c = {},
                    _c[baseStyles.controlInputInvalid] = props.isValid === false,
                    _c[inputStyles.inputDisabled] = props.disabled,
                    _c)), onClick: props.disabled ? undefined : function () { return setModalVisible(!modalVisible); } },
                props.selection && (React.createElement("span", null,
                    formatPercent(props.selection.x),
                    ",",
                    ' ',
                    formatPercent(props.selection.y),
                    ",",
                    ' ',
                    formatPercent(props.selection.width),
                    ",",
                    ' ',
                    formatPercent(props.selection.height))),
                React.createElement(Modal, { visible: modalVisible, close: function () { return setModalVisible(false); }, updateSelection: props.updateSelection, initialSelection: props.selection, file: props.file })),
            props.isValid === false && (React.createElement("div", { className: baseStyles.validationMessage }, props.validationMessage)))));
}
